import React from "react";

const EyeOnIcon = React.forwardRef(
    function EyeOnIcon(
        {
            title,
            titleId,
            ...props
        },
        svgRef
    ) {
        return (
            <svg
                viewBox="0 0 24 24"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                ref={svgRef}
                aria-labelledby={titleId}
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-eye"
                {...props}
            >
                {title ? <title id={titleId}>{title}</title> : null}
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
            </svg>
        );
    }
);

export default EyeOnIcon;
